<script>
/**
 * ****************************************************************************
 * @description     :   Multi Select Component
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import MultiSelect from 'primevue/multiselect';
/**
 * Import template
 */
import template from './template.html';
// import helpers from '@/utils/helpers';

/**
 * Define content of select component
 */
var AnsMultiSelect = {
    template: template,
    components: { MultiSelect },
    props: {
        id: String,
        label: String,
        name: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: [String, Number],
        modelValue: [String, Number],
        emptyText: String,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        isFromSearch: {
            type: Boolean,
            default: false
        },
        removeEmptyOption: {
            type: Boolean,
            default: false
        },
        options: Array,
        onChange: Function,
        onFocus: Function,
        onBlur: Function,
        keyValueOptions: {
            type: Array,
            default: ['code', 'name']
        },
        positionReferValue: {
            type: Number,
            default: 0
        },
        isTab: {
            type: Boolean,
            default: false
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        widthLabel: {
            type: String,
            default: 'width-110-px'
        },
        errors: {
            type: Array
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            values: []
        };
    },
    watch: {
        values(val) {
            if (val) {
                const value = val.map((item) => item.code);
                this.$emit('update:modelValue', value);
            }
        }
    },
    methods: {}
};
export default AnsMultiSelect;
</script>
